import { render, staticRenderFns } from "./NewDistributorAdd.vue?vue&type=template&id=b0139d14&scoped=true"
import script from "./NewDistributorAdd.vue?vue&type=script&lang=js"
export * from "./NewDistributorAdd.vue?vue&type=script&lang=js"
import style0 from "./NewDistributorAdd.vue?vue&type=style&index=0&id=b0139d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0139d14",
  null
  
)

export default component.exports